import { featureItems } from '@/mocks/home';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-primary-600 mb-2">核心优势</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">为什么选择我们</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">五大核心优势，重新定义你的在线观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item, i) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-300 text-center"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl mx-auto mb-4 flex items-center justify-center transition-colors duration-300 ${
                i === 0 ? 'bg-primary-100 group-hover:bg-primary-200' :
                i === 1 ? 'bg-accent-100 group-hover:bg-accent-200' :
                i === 2 ? 'bg-secondary-100 group-hover:bg-secondary-200' :
                i === 3 ? 'bg-primary-100 group-hover:bg-primary-200' :
                'bg-accent-100 group-hover:bg-accent-200'
              }`}>
                <i className={`${item.icon} text-xl md:text-2xl ${
                  i === 0 ? 'text-primary-600' :
                  i === 1 ? 'text-accent-600' :
                  i === 2 ? 'text-secondary-600' :
                  i === 3 ? 'text-primary-600' :
                  'text-accent-600'
                }`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}